import React from 'react';
import { FDSecondaryActionIconButton, FDStack } from '@facet-wealth/design';
import PropTypes from 'prop-types';
import { useSwiperReactive } from './useSwiperReactive';

export const CarouselControls = ({ numCards, maxCardsVisible }) => {
  const swiper = useSwiperReactive();

  return (
    <FDStack spacing={1} width={'100%'} alignItems={'center'} justifyContent={'center'}>
      <FDSecondaryActionIconButton
        onClick={() => swiper.slidePrev()}
        icon={'keyboardArrowLeft'}
        appearance={'icon'}
        disabled={swiper.activeIndex === 0}
      />
      <FDSecondaryActionIconButton
        onClick={() => swiper.slideNext()}
        icon={'keyboardArrowRight'}
        appearance={'icon'}
        disabled={Math.floor(swiper.activeIndex + maxCardsVisible) >= numCards}
      />
    </FDStack>
  );
};


CarouselControls.propTypes = {
  numCards: PropTypes.number.isRequired,
  maxCardsVisible: PropTypes.number.isRequired,
};
